import React from 'react';
import styled from 'styled-components';

const ExperienceSection = styled.section`
  padding: 70px;
  color: #fff;
  max-width: 800px;
  margin: 20px auto 0 auto;
  font-family: "Garamond", serif;
  background-color: rgb(23, 29, 41);

 @media (max-width: 768px) {
    padding: 50px 20px;
  }

  @media (max-width: 480px) {
     padding: 30px 15px;
  }
`;

const ExperienceList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const ExperienceItem = styled.li`
  background-color: #253342;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  transition: background-color 0.3s;
  display: flex;
  justify-content: space-between;
  gap: 20px;

  &:hover {
    background-color: #444;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Logo = styled.img`
  width: 60px;
  height: 60px;
  margin-right: 20px;
  border-radius: 8px;
  object-fit: cover;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 15px;
  }
`;

const Details = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }
`;

const RoleCompany = styled.div`
  display: flex;
  flex-direction: column;
`;

const Role = styled.h2`
  margin: 0;
  font-size: 1.25em;

  @media (max-width: 480px) {
    font-size: 1.1em;
  }
`;

const Company = styled.h3`
  margin: 0;
  font-size: 1.1em;
  color: #aaa;

  @media (max-width: 480px) {
    font-size: 1em;
  }
`;

const DurationLocation = styled.div`
  text-align: right;
  font-size: 1em;
  color: #aaa;

  @media (max-width: 768px) {
    text-align: center;
    font-size: 0.95em;
  }
`;

const Description = styled.p`
  margin-top: 10px;
  line-height: 1.6;
  font-size: 1.1em;

  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 480px) {
    font-size: 0.95em;
  }
`;

const Experience = () => {
  return (
    <ExperienceSection id="experience">
      <h1>Experience</h1>
      <ExperienceList>
        
        <ExperienceItem>
          <Logo src={`${process.env.PUBLIC_URL}/GE_logo.png`} alt="GE logo" />
          <Details>
            <Header>
              <RoleCompany>
                <Role>Digital Technology Intern - Data Science and Analytics</Role>
                <Company>GE Aerospace</Company>
              </RoleCompany>
              <DurationLocation>
                <div>January 2025 - June 2025</div>
                <div>Bengaluru, India</div>
              </DurationLocation>
            </Header>
            <Description>
              As part of the Image Analytics team, I worked on automating the detection and segmentation of 11 key blade features in industrial borescope inspection images using deep learning techniques.
              <br /><br />
              I created a high-quality annotated dataset by labeling borescope images of aircraft engines, focusing on those from the Middle East—where existing models underperformed due to harsh environmental conditions like dust and sand ingestion.
              <br /><br />
              I initially experimented with RetinaNet for rotated/oriented object detection, but due to limited performance, pivoted to a DenseNet+UNet-based semantic segmentation approach. I deployed the final model on AWS using GPU instances, achieving 87% precision and 77% recall, with significantly improved results on Middle Eastern engine data.
            </Description>
          </Details>
        </ExperienceItem>

        <ExperienceItem>
          <Logo src={`${process.env.PUBLIC_URL}/JPM.jpeg`} alt="JPMorgan logo" />
          <Details>
            <Header>
              <RoleCompany>
                <Role>Software Engineer Intern</Role>
                <Company>JPMorgan Chase</Company>
              </RoleCompany>
              <DurationLocation>
                <div>June 2024 - August 2024</div>
                <div>Glasgow, UK</div>
              </DurationLocation>
            </Header>
            <Description>
              I designed and implemented a data monitoring application for Asset Management feeds, leveraging an in-house API, Spring Boot,
              Oracle, Elasticsearch, and Kibana. The app tracked feed performance, SLA breaches, and status metrics.
              <br /><br />
              I contributed across the entire Software Development Life Cycle (SDLC) and helped deploy the app on JPMorgan’s on-premises cloud.
            </Description>
          </Details>
        </ExperienceItem>

        <ExperienceItem>
          <Logo src={`${process.env.PUBLIC_URL}/JPM.jpeg`} alt="JPMorgan logo" />
          <Details>
            <Header>
              <RoleCompany>
                <Role>Software Engineer Intern</Role>
                <Company>JPMorgan Chase</Company>
              </RoleCompany>
              <DurationLocation>
                <div>June 2023 - August 2023</div>
                <div>Glasgow, UK</div>
              </DurationLocation>
            </Header>
            <Description>
              I worked on automation testing for critical features in JPMorgan’s investment banking platform using BDD with Cucumber and Groovy.
              <br /><br />
              Additionally, I built an LSTM-based deep learning model to auto-generate test scripts, improving test efficiency by 90%.
            </Description>
          </Details>
        </ExperienceItem>

      </ExperienceList>
    </ExperienceSection>
  );
};

export default Experience;
